/**
 * 月度趋势标杆分析看板 — POST /api/produce/kanban/monthly-trend-benchmark
 */
import request from '@/router/axios'

const API = '/api/produce/kanban/monthly-trend-benchmark'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

/**
 * @param {object} data year, businessCategory, planType, benchmarkPercent, planTableLimit
 */
export function fetchMonthlyTrendBenchmark(data = {}) {
  return request({
    url: API,
    method: 'post',
    data
  }).then(unwrap)
}
